import api from "./Urls";

export const requestPasswordReset = async (email) => {
  const response = await api.post(
    "/api/auth/password-reset/request",
    {
      email: email.trim().toLowerCase(),
    }
  );

  return response.data;
};

export const verifyPasswordResetCode = async (
  email,
  code
) => {
  const response = await api.post(
    "/api/auth/password-reset/verify",
    {
      email: email.trim().toLowerCase(),
      code: code.trim(),
    }
  );

  return response.data;
};

export const completePasswordReset = async (
  resetToken,
  newPassword
) => {
  const response = await api.post(
    "/api/auth/password-reset/complete",
    {
      resetToken,
      newPassword,
    }
  );

  return response.data;
};
